/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { computed } from '@ember/object';
import Component from '@ember/component';
import { isNone } from '@ember/utils';
import { tagName } from '@ember-decorators/component';

@tagName('')
export default class Alert extends Component {
  // external API
  delivery = null;
  hasReadOnlyPermission = false;

  detail = null;

  // internal API
  @computed('delivery.customer')
  get hasCustomer() {
    return this.delivery.belongsTo('customer').id() != null;
  }

  @computed('delivery.action')
  get hasAction() {
    return this.delivery.belongsTo('action').id() != null;
  }

  @computed('delivery.{actionType,hasBeenSent,isSuppressed,isBounced,deviceStatuses,isHoldout}')
  get isHidden() {
    let { actionType, hasBeenSent, isSuppressed, isBounced, isSpammed, deviceStatuses, isHoldout } = this.delivery;

    if (isHoldout) {
      return true;
    }

    if (actionType === 'push_action' && !isNone(deviceStatuses)) {
      return true;
    }

    if (isSuppressed || isBounced || isSpammed) {
      return false;
    }

    return hasBeenSent;
  }
}
